import { type VariantInfoDisplayType } from '../types/VariantInfoDisplayType';

export const VariantInfoDisplayTypes: Record<VariantInfoDisplayType, VariantInfoDisplayType> = {
    TEXT: 'TEXT',
    SELECT: 'SELECT',
    IMAGE: 'IMAGE',
    COLOR: 'COLOR',
} as const;
